export default __webpack_public_path__ + "static/media/defaultTeamLogo2.65a1fd7e.png";